import { Route, Routes } from "react-router-dom";
import LeftToRight from 'pages/frontend/LeftToRight'
import RightToLeft from 'pages/frontend/RightToLeft'
import Demos from 'pages/demos'

export default function index() {
    return (
        <>
            <Routes>
                {/* Here we have three routes and we know that routes used for paths. In "/" route I am showing first page of website 
                and i think that will not important for you so you can change the route but be careful because if you want that your portfolio
                will execute on "/" route then you have to change more things in website. Ex. in navbar you have to change the "Link" in which you can
                remove "/left_to_right" or "/right_to_left".
                And in this file you have to replace <Demos/> into <LeftToRight/> or <RightToLeft/> according to your need. For example if you want LTR version then replace with <LeftToRight/>   
                And change the "Link" in "Hero" file too
                */}
                <Route path="/" element={<Demos />} />
                <Route path="/left_to_right/*" element={<LeftToRight />} />
                <Route path="/right_to_left/*" element={<RightToLeft />} />
            </Routes>
        </>
    )
}
